type Tone = 'neutral' | 'sage' | 'bronze' | 'ink' | 'faint';

const TONES: Record<Tone, string> = {
  neutral: 'bg-surface-sunken text-ink-soft',
  sage: 'bg-sage/15 text-sage-dark',
  bronze: 'bg-bronze-light/40 text-bronze',
  ink: 'bg-ink text-white',
  faint: 'bg-surface-alt text-ink-faint',
};

export function Pill({ tone = 'neutral', children }: { tone?: Tone; children: React.ReactNode }) {
  return (
    <span
      className={`inline-flex items-center whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-semibold ${TONES[tone]}`}
    >
      {children}
    </span>
  );
}
